import { Link } from '@remix-run/react'

export function UnauthUser() {
  return (
    <div style={{
      background: "#141416",
      border: "1px solid rgba(255,255,255,0.07)",
      borderRadius: 10,
      padding: 16,
      display: "flex",
      flexDirection: "column",
      gap: 12,
    }}>
      <div>
        <div style={{ color: "#f0f0f2", fontWeight: 600, fontSize: 13, marginBottom: 4 }}>
          Login to play
        </div>
        <div style={{ color: "#8a8a95", fontSize: 12, lineHeight: 1.4 }}>
          Sign up or sign in to play.
        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        <Link to="/login" style={{ display: "block", width: "100%" }}>
          <button
            style={{
              width: "100%",
              background: "#00c5a0",
              color: "#0a0a0b",
              border: "none",
              borderRadius: 8,
              padding: "8px 0",
              fontSize: 13,
              fontWeight: 600,
              cursor: "pointer",
              transition: "opacity 0.15s",
            }}
            onMouseEnter={e => (e.currentTarget.style.opacity = "0.85")}
            onMouseLeave={e => (e.currentTarget.style.opacity = "1")}
          >
            Log in
          </button>
        </Link>
        <Link to="/signup" style={{ display: "block", width: "100%" }}>
          <button
            style={{
              width: "100%",
              background: "rgba(255,255,255,0.05)",
              color: "#f0f0f2",
              border: "1px solid rgba(255,255,255,0.07)",
              borderRadius: 8,
              padding: "8px 0",
              fontSize: 13,
              fontWeight: 500,
              cursor: "pointer",
              transition: "background 0.15s",
            }}
            onMouseEnter={e => (e.currentTarget.style.background = "rgba(255,255,255,0.09)")}
            onMouseLeave={e => (e.currentTarget.style.background = "rgba(255,255,255,0.05)")}
          >
            Sign up
          </button>
        </Link>
      </div>
    </div>
  )
}
